import { AppProps, NextWebVitalsMetric } from 'next/app'
import React from 'react'
import { Provider } from 'react-redux'
import store from '../core/store'
import { transformMetricName } from '../utils/transformMetricName'

import useAppTracking from '../core/hooks/useAppTracking'
import PurchaseLoggerProvider from '../core/providers/purchaseProvider'
import ReactQueryProvider from '../core/providers/reactQueryProvider'

import { PageProps } from '@/core/types/interfaces'
import '@bees-web/nfa-components-react/lib/themes/base.scss'
import '../core/logging/clientLogger'
import '/public/fonts/global.css'

import { PendoScript } from '@/features/pendo/components/PendoScript'

import DevToolProvider from '../features/devtools/provider'

const BeesWebApp = ({
  Component,
  pageProps,
}: AppProps<PageProps>): React.JSX.Element => {
  const { context, configuration, __devToolsEnabled } = pageProps
  const { country, page, session } = context || {}

  const devToolsEnabled = __devToolsEnabled ?? false

  useAppTracking({
    country,
    pageKey: page?.key,
    userInfos: session?.user,
    configuration,
  })

  return (
    <Provider store={store}>
      <ReactQueryProvider>
        <PurchaseLoggerProvider>
          <DevToolProvider isEnabled={devToolsEnabled} pageProps={pageProps}>
            <div className='main'>
              <Component {...pageProps} />
            </div>
          </DevToolProvider>
          <PendoScript />
        </PurchaseLoggerProvider>
      </ReactQueryProvider>
    </Provider>
  )
}

export function reportWebVitals(metric: NextWebVitalsMetric): void {
  if (typeof window.newrelic === 'object') {
    window.newrelic.setCustomAttribute(
      transformMetricName(metric.name, metric.label),
      metric.value
    )
  }
}

export default BeesWebApp
